/* -----------------Globals--------------- */
import { Stack, useLocalSearchParams, useRouter } from "expo-router";

/* -----------------UI--------------- */
import { Button } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import useSuggestCorrection from "@features/session/hooks/useSuggestCorrection";

import { pageViewTypes } from "@constants/tracking";
import { SuggestCorrectionForm } from "@features/session/components/SuggestCorrectionForm";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Child components--------------- */
import Box from "@memorang/ui/components/Box";
import ModalHeader from "@memorang/ui/components/ModalHeader";

const SuggestCorrectionRoute = () => {
	const { index } = useLocalSearchParams<{
		index: string;
	}>();
	const currentItemIndex = index ? Number.parseInt(index) : 0;

	const {
		setCorrection,
		correction,
		setSource,
		source,
		loading,
		callSuggestCorrection,
	} = useSuggestCorrection(currentItemIndex);
	useAnalytics({
		type: pageViewTypes.suggestCorrection,
	});

	const router = useRouter();
	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader
							backIcon="arrow-left"
							headerTitle="Suggest Correction"
							onBack={() => router.back()}
							headerRight={() => {
								return (
									<Button
										disabled={loading || !source || !correction}
										loading={loading}
										onPress={async () => {
											await callSuggestCorrection({
												source,
												correction,
											});
											router.back();
										}}
									>
										Submit
									</Button>
								);
							}}
						/>
					),
				}}
			/>
			<Box padding={16}>
				<SuggestCorrectionForm
					setCorrection={setCorrection}
					setSource={setSource}
					source={source}
					correction={correction}
				/>
			</Box>
		</>
	);
};

export default SuggestCorrectionRoute;
